import angular from 'angular';
import MenuDirective from './menu.directive';
import MenuItemModule from './menu-item/menu-item';

let MenuModule = angular.module('home.menu', [
  MenuItemModule.name
])
  .directive('menu', MenuDirective);

export default MenuModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/home/menu/menu.js
 **/